<div class="relative h-full w-full">
  <ng-content></ng-content>

  <mat-sidenav
    [mode]="'side'"
    [opened]="!!state.asset"
    [position]="'end'"
    class="w-[400px] border-gray-100"
    [disableClose]="true"
  >
    <mat-progress-bar class="w-full" mode="indeterminate" *ngIf="state.isLoading"></mat-progress-bar>
    <div class="asset-wrapper" [hidden]="!state.asset || state.isLoading">
      <div class="asset-navigation">
        <ng-container *ngIf="isAssetSidebarRouted">
          <button
            *ngFor="let tab of state.tabs; trackBy: trackByType"
            mat-button
            matTooltipPosition="right"
            [matTooltip]="tab.label"
            class="asset-navigation-btn"
            routerLinkActive
            #rla="routerLinkActive"
            [class.active]="rla.isActive"
            [attr.data-test]="'button-asset-sidebar-tab-' + tab.type"
            [routerLink]="[tab.type]"
          >
            <fa-icon class="fs-09" *ngIf="tab.isFontAwesome" [icon]="['fal', tab.logo]"></fa-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="!isAssetSidebarRouted">
          <button
            *ngFor="let tab of state.tabs; trackBy: trackByType"
            mat-button
            matTooltipPosition="right"
            [matTooltip]="tab.label"
            class="asset-navigation-btn"
            [class.active]="state.activeTabType === tab.type"
            [attr.data-test]="'button-asset-sidebar-tab-' + tab.type"
            (click)="setActiveTab(tab)"
          >
            <fa-icon class="fs-09" *ngIf="tab.isFontAwesome" [icon]="['fal', tab.logo]"></fa-icon>
          </button>
        </ng-container>
      </div>
      <div class="asset-main-area">
        <button mat-icon-button (click)="closeSidebar()" class="close-button-default" *ngIf="!!state.asset">
          <fa-icon class="fs-01 text-gray-1100" [icon]="['fal', 'times']"></fa-icon>
        </button>
        <div class="asset-main-area-title">
          <img
            *ngIf="state.asset?.typeIcon"
            width="21"
            style="max-height: 30px"
            class="mr-2"
            [matTooltip]="state.asset?.typeLabel || ''"
            [src]="state.asset?.typeIcon"
            [alt]="state.asset?.typeLabel"
          />
          <div class="asset-sidebar-section-title truncate" [matTooltip]="state.asset?.name || ''">
            {{ state.asset?.name }}
          </div>
          <button
            *ngIf="state.isRedirectToDetailViewVisible"
            mat-icon-button
            class="ml-[4px] link-button"
            (click)="redirectToDetailView()"
            [intercomTarget]="'asset-redirect-to-detail-view'"
            [matTooltip]="'Redirect to Detail View'"
            matTooltipPosition="above"
          >
            <fa-icon [icon]="['fal', 'up-right-from-square']"></fa-icon>
          </button>
        </div>
        <div class="asset-main-area-body">
          <ng-container *ngIf="isAssetSidebarRouted">
            <router-outlet></router-outlet>
          </ng-container>
          <ng-container *ngIf="!isAssetSidebarRouted">
            <div y42AssetSidebarTab [activeTab]="state.activeTab"></div>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-sidenav>
</div>
